import { _ } from "../../core/polyglot/polyglot.js";
import accountingDocument from "./accountingDocument.js";
import routeNotFoundWidget from "../../core/widgets/routeNotFoundWidget.js";

/**
 * Todo: Add JSDoc comment
 */
function routeNotFoundDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = accountingDocument(spec, my);

	that.title = _("Page not found");

	my.routeNotFoundWidget = routeNotFoundWidget();

	that.hasActionsMenu = function () {
		return false;
	};

	my.renderContentOn = function (html) {
		html.render(my.routeNotFoundWidget);
	};

	return that;
}

export default routeNotFoundDocument;
